/** Interface languages (ADR-0011). */
export interface LanguageInfo {
  code: string;
  /** Name in the language itself, for the language picker. */
  nativeName: string;
  englishName: string;
  rtl: boolean;
  /** LAUNCH = phase 1/2 launch set; NEXT = next wave. */
  wave: 'LAUNCH' | 'NEXT';
}

export const LANGUAGES: LanguageInfo[] = [
  { code: 'en', nativeName: 'English', englishName: 'English', rtl: false, wave: 'LAUNCH' },
  { code: 'es', nativeName: 'Español', englishName: 'Spanish', rtl: false, wave: 'LAUNCH' },
  { code: 'pt', nativeName: 'Português', englishName: 'Portuguese', rtl: false, wave: 'LAUNCH' },
  { code: 'fr', nativeName: 'Français', englishName: 'French', rtl: false, wave: 'LAUNCH' },
  { code: 'de', nativeName: 'Deutsch', englishName: 'German', rtl: false, wave: 'LAUNCH' },
  { code: 'it', nativeName: 'Italiano', englishName: 'Italian', rtl: false, wave: 'LAUNCH' },
  { code: 'nl', nativeName: 'Nederlands', englishName: 'Dutch', rtl: false, wave: 'LAUNCH' },
  { code: 'pl', nativeName: 'Polski', englishName: 'Polish', rtl: false, wave: 'LAUNCH' },
  { code: 'ro', nativeName: 'Română', englishName: 'Romanian', rtl: false, wave: 'NEXT' },
  { code: 'el', nativeName: 'Ελληνικά', englishName: 'Greek', rtl: false, wave: 'NEXT' },
  { code: 'cs', nativeName: 'Čeština', englishName: 'Czech', rtl: false, wave: 'NEXT' },
  { code: 'sv', nativeName: 'Svenska', englishName: 'Swedish', rtl: false, wave: 'NEXT' },
  { code: 'da', nativeName: 'Dansk', englishName: 'Danish', rtl: false, wave: 'NEXT' },
  { code: 'fi', nativeName: 'Suomi', englishName: 'Finnish', rtl: false, wave: 'NEXT' },
  { code: 'hu', nativeName: 'Magyar', englishName: 'Hungarian', rtl: false, wave: 'NEXT' },
  { code: 'tr', nativeName: 'Türkçe', englishName: 'Turkish', rtl: false, wave: 'NEXT' },
  { code: 'ar', nativeName: 'العربية', englishName: 'Arabic', rtl: true, wave: 'NEXT' },
];

export function languageInfo(code: string): LanguageInfo | undefined {
  const base = code.split('-')[0];
  return LANGUAGES.find((l) => l.code === code) ?? LANGUAGES.find((l) => l.code === base);
}

export function isRtl(code: string): boolean {
  return languageInfo(code)?.rtl ?? false;
}

/** Best supported language for a browser's preference list. */
export function negotiateLanguage(preferred: readonly string[], supported: readonly string[] = LANGUAGES.map((l) => l.code)): string {
  for (const p of preferred) {
    const lower = p.toLowerCase();
    if (supported.includes(lower)) return lower;
    const base = lower.split('-')[0]!;
    if (supported.includes(base)) return base;
  }
  return 'en';
}
